module.exports = __webpack_public_path__ + "img/WeCom.6498e10f.png";